import { ApolloClient, InMemoryCache, HttpLink, split } from "@apollo/client";
import { getMainDefinition } from "@apollo/client/utilities";
import { WebSocketLink } from "@apollo/client/link/ws";
import Auth from "./auth";

export const cache = new InMemoryCache();

export const createClient = (noHeaders?: boolean) => {
  let authHeader: any = {
    authorization: `Bearer ${new Auth().accessToken()?.token}`,
  };

  if (!!noHeaders) {
    authHeader = {};
  }

  if (!new Auth().accessToken()) {
    authHeader = {};
  }

  const httpLink = new HttpLink({
    uri: process.env.REACT_APP_GRAPHQL,
    // @ts-ignore
    headers: {
      "content-type": "application/json",
      ...authHeader,
    },
  });

  const wsLink = new WebSocketLink({
    uri: process.env.REACT_APP_GRAPHQL.replace(/^https?/, "wss"),
    options: {
      reconnect: true,
      lazy: true,
      connectionParams: {
        headers: {
          ...authHeader,
        },
      },
    },
  });

  // The split function takes three parameters:
  //
  // * A function that's called for each operation to execute
  // * The Link to use for an operation if the function returns a "truthy" value
  // * The Link to use for an operation if the function returns a "falsy" value
  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === "OperationDefinition" &&
        definition.operation === "subscription"
      );
    },
    wsLink,
    httpLink
  );

  return new ApolloClient({
    cache,
    defaultOptions: { watchQuery: { fetchPolicy: "cache-and-network" } },
    link: splitLink,
  });
};
